<script>
	import { onMount } from "svelte";

	import studioImages from "../static/studio.js";

	import About from '../components/about.svelte';

	import Illustrations from '../components/illustrations.svelte';

	import Contact from '../components/contact.svelte';

	export let name;
	
	let studioContainer;

	/* 
	 * bind:this={studioContainer}
	 * {#each studioImages as image}
			<img src="build/assets/img/studio/{image}" class="img-responsive" />
		{/each}
	 */
	/* onMount(() => {
		studioContainer.addEventListener("scroll", () => {
			if (
				window.innerWidth + studioContainer.scrollLeft >=
				studioContainer.scrollWidth
			) {
				studioContainer.scrollLeft = 0;
			}
		});

		function studioImageScroll() {
			studioContainer.scrollBy(1, 0);
			let scrollDelay = setTimeout(studioImageScroll, 10);
		}
		studioImageScroll();
	}); */
</script>

<svelte:head>
	<title>wangsichun studio</title>
</svelte:head>

<div class="bg-wrapper bg-secondary" id="home">
	<div class="intro-container">
		<h1><span class="emphasis">wangsichun</span> studio</h1>
		<h5>timeless art</h5>
		<img src="build/assets/img/profile.jpg" class="img-circle" />
		<p>
			<a class="text-white text-decoration-underline" href="https://www.instagram.com/nicolebabysg/">
				Follow me on Instagram @nicolebabysg
			</a>
		</p>
	</div>

	<div class="bg" ></div>
</div>

<About />

<Illustrations />

<Contact />

<style lang="scss">
	@import "src/scss/home";

	.img-circle {
		width: 40%;
		border-radius: 50%;
	}

	@include media-breakpoint-up(md) {
		.img-circle {
			width: 15%;
		}
	}

	@include media-breakpoint-up(md) {
		.bg {
			background-image: url('assets/img/studio/WhatsApp Image 2022-04-16 at 11.57.35 PM.jpeg');
			background-repeat: no-repeat;
			background-size: cover;
		}
	}
</style>
